module.exports = __webpack_public_path__ + "img/logo_fb.170a7013.png";